import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserService } from './user.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';


@Injectable({
  providedIn: 'root'
})
export class PackageService {
  private stateSubject = new BehaviorSubject<{ [key: string]: any }>({});
  public state$ = this.stateSubject.asObservable();
  public allPackages: any;
  public myPackages:any;
  constructor(private http: HttpClient, private user: UserService) { }

  setValue(key: string, value: any): void {
    const currentState = this.stateSubject.value;
    this.stateSubject.next({
      ...currentState,
      [key]: value
    });
  }

  getHpValue(key: string): any {
    return this.stateSubject.value[key];
  }

  getAllHpValues(): { [key: string]: any } {
    return this.stateSubject.value;
  }

  clearAllValues(): void {
    this.stateSubject.next({});
  }

  setAllPackages(data) {
    this.allPackages = data;
  }

  getAllPackages() {
    return this.allPackages;
  }  

  removeValue(key: string): void {
  const currentState = this.stateSubject.value;
  const { [key]: removed, ...newState } = currentState;
  this.stateSubject.next(newState);
  }
  
  
  public getPackageForAppt(appointment): Observable<any> {
    return new Observable(observer => {
      let pkg = appointment.packageInfo
      this.getPacketOrderSetId(appointment, pkg).subscribe(orderSetId => {
        pkg.orderSetId = orderSetId
        let inparam = {
          patientId: appointment.uhid,
          facilityId: appointment.facilityId,
          package: [
            {
              packageCode: pkg.packageCode,
              packageSeq: pkg.subscriptionId || 1,
              appointmentId: appointment.appointmentId,
              orderSetId: pkg.orderSetId
            }
          ]
        }
        this.getPackageDetail(inparam).subscribe(utilisation => {
          observer.next({ packageUtilisation: utilisation })
        }, err => {
          observer.error(false);
        })
      })
    })
  }

  private getPacketOrderSetId(appointment, pkg): Observable<any>{
    return new Observable(observer => {
      if (pkg.orderSetId) return observer.next(pkg.orderSetId)
      let payload = {
        patientIds: [appointment.uhid],
        status: 'A'
      }
      this.getPackages(payload).subscribe(packageResponse => {
        let packageData = packageResponse.find(res => res.appointment_ids?.length > 0 ? res.appointment_ids.includes(appointment.appointmentId) : res.appointment_id == appointment.appointmentId)
        observer.next(packageData?.orderSetId)
      }, err => {
        observer.next(null)
      })
    })
  }

  public getPackages(inparam, isBackground: boolean = false): Observable<any> {
    let payload = {
      'personId': this.user.getPersonId(),
      isBackgroundProcess: isBackground,
      ...inparam
    }
    return new Observable(observer => {
      if (inparam['patientIds'].length == 0) {
        observer.next([]);
        observer.complete();
        return;
      }
      this.http.post(`${this.user.getRepoUrl()}api/packages/getMyPackages`, payload, { reportProgress: false }).subscribe(data => {
        observer.next(data['data']);
        this.myPackages=data['data']
        observer.complete();
      }, error => {
        observer.error()
        observer.complete();
      })
    })
  }

  

  public getSubscribedPackages(){
    return this.myPackages || [];
  }
  
  public getPackageDetail(inparam): Observable<any> {
    let payload = {
      'personId': this.user.getPersonId(),
      isBackgroundProcess: false,
      ...inparam
    }
    return new Observable(observer => {
      this.http.post(`${this.user.getRepoUrl()}api/packages/packageSubUtilization`, payload, { reportProgress: false }).subscribe(data => {
        observer.next(data['data']);
        observer.complete();
      }, error => {
        observer.error()
        observer.complete();
      })
    })
  }

  public validatePackageLink(orderSetId: string, password: string, hash: string): Observable<any> {
    const payload = {
      orderSetId: orderSetId,
      password: password,
      hash: hash
    }
    return Observable.create(observer => {
      this.http.post(`${environment['API_URL']}api/schedules/validatePackageLink`, payload, { reportProgress: true }).subscribe((data) => {
        observer.next(data['data']);
        observer.complete();
      }, error => {
        observer.error(error);
        observer.complete();
      })
    })
  }

  public getPackageCharges(payload): Observable<any> {
    return new Observable(observer => {
      this.http.post(`${this.user.getRepoUrl()}api/schedules/getchargeforpackage`, payload, { reportProgress: false, }).subscribe(data => {
        observer.next(data['data']);
        observer.complete();
      }, error => {
        observer.error()
        observer.complete();
      })
    })
  }
}
